/**
 * Flags de contenu pour la release v1.
 * Repasser un flag à true réactive la section correspondante, rien d'autre à toucher.
 */
export const CONTENT_FLAGS = {
  // Section "Improvisations" (vidéo artiste vedette) + carousel "More Inspiration"
  showArtistVideos: false,

  // Artistes payants (Per Nilsson) dans toutes les listes + flow d'achat
  showPaidArtists: true,

  // Carousel "More Backing Tracks" en bas de l'onglet Learn
  showMoreBackingTracksCarousel: false,

  // Découpage "Perfect Match / Compatible / Explore" dans "Jam On This"
  // (false = liste plate, plus propre avec peu de pistes)
  splitTracksByRelevance: true
};

export default CONTENT_FLAGS;
